import { Directive } from '@angular/core';

@Directive({
    selector: '[apxSuffix]',
    standalone: true
})
export class ApxSuffixDirective {}
